export enum WarrantyActivationMethod {
  SERIAL_NUMBER = 1,
  REFERENCE_NUMBER = 2
}
